import type { InstallmentCalculatorConfig } from '../../default/product/installmentCalculator.types';
import type { DeepPartial } from '../../default/types';

export const installmentCalculatorConfig: DeepPartial<InstallmentCalculatorConfig> = {
  hasLegalHints: true,
  hasInfoCallToAction: false,
  InstallmentCalculatorCallToActionLayout: { layout: 'Layout1' },
  resetInstallmentsOnPriceChange: false,
};
